import { ThumbsUp } from 'lucide-react';

interface LikeBadgeProps {
  iconOnly?: boolean;
}

export function LikeBadge({ iconOnly = false }: LikeBadgeProps) {
  return (
    <div
      style={{
        display: 'inline-flex', // inline-flex
        alignItems: 'center', // items-center
        gap: '6px', // gap-1.5
        borderStyle: 'solid', // border
        borderWidth: '1px',
        flexShrink: 0, // flex-shrink-0

        backgroundColor: 'transparent',
        borderColor: 'var(--success)',
        borderRadius: '9999px',
        paddingLeft: iconOnly ? '5px' : '8px',
        paddingRight: iconOnly ? '5px' : '8px',
        paddingTop: '3px',
        paddingBottom: '3px',
        minHeight: '22px',
        minWidth: iconOnly ? '22px' : 'auto',
        justifyContent: 'center',
      }}
    >
      <ThumbsUp
        style={{
          width: '14px', // w-3.5
          height: '14px', // h-3.5
          stroke: 'var(--success)',
          fill: 'none',
          strokeWidth: '2',
        }}
      />
      {!iconOnly && (
        <span
          style={{
            fontSize: 'var(--text-xs)',
            fontWeight: 'var(--font-weight-medium)',
            color: 'var(--success)',
            lineHeight: 'normal',
          }}
        >
          Gostei
        </span>
      )}
    </div>
  );
}
